"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _API2 = _interopRequireDefault(require("./API"));

var URL = 'websitegrader/v2/grade/';
var timeout = 60000;

var _default =
/*#__PURE__*/
function (_API) {
  (0, _inherits2.default)(_default, _API);

  function _default() {
    (0, _classCallCheck2.default)(this, _default);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(_default).apply(this, arguments));
  }

  (0, _createClass2.default)(_default, [{
    key: "get",
    value: function get(websiteUrl) {
      return this.makeGetRequest(URL + websiteUrl, {
        timeout: timeout
      });
    }
  }, {
    key: "post",
    value: function post(websiteUrl) {
      return this.makePostRequest(URL + websiteUrl, {
        timeout: timeout
      });
    }
  }]);
  return _default;
}(_API2.default);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/api/GraderAPI.js
// module id = 251
// module chunks = 0